import { lazy } from 'react';
import Loadable from './Loadable';
import { AuthRoutes } from './auth';
import { PublicRoutes } from './public';
import { DashboardRoutes } from './dashboard';
import { AdminRoutes } from './admin';
import { ComponentRoutes } from './components';
import { Navigate } from 'react-router-dom';
import { IS_GUEST_VIEW } from '../app.config';

// GLOBAL ERROR PAGE
const ErrorPage = Loadable(lazy(() => import('pages/404')));
// LANDING / INITIAL PAGE
const Login = Loadable(lazy(() => import('pages/sessions/login')));
const GuestLogin = Loadable(
  lazy(() => import('pages/sessions/loginGuestPage'))
);
const hasToken = () => {
  // Replace with your actual token retrieval logic
  return !!localStorage.getItem('token') || !!sessionStorage.getItem('token');
};

const isGuest = IS_GUEST_VIEW;

// Smart redirect component that checks permissions
const SmartRedirect = Loadable(lazy(() => import('components/auth/SmartRedirect')));

export const routes = () => {
  return [
    // INITIAL / INDEX PAGE
    {
      path: '/',
      element: hasToken() ? (
        <SmartRedirect />
      ) : isGuest ? (
        <GuestLogin />
      ) : (
        <Login />
      )
    },
    // GLOBAL ERROR PAGE
    {
      path: '*',
      element: <ErrorPage />
    },
    // AUTHENTICATION PAGES ROUTES & DIFFERENT AUTH DEMO PAGES ROUTES
    ...AuthRoutes,
    // COMPONENTS PAGES ROUTES
    ...ComponentRoutes,
    // INSIDE DASHBOARD PAGES ROUTES
    ...DashboardRoutes,
    ...AdminRoutes,
    // PAGES ROUTES
    ...PublicRoutes
  ];
};
